export const SMART_PROFILE_BASE_URL = "https://dproz-smart-profiles.s3.amazonaws.com";

/**
 * Builds the public URL for a document stored in the Smart Profile bucket.
 *
 * The stored `storage_key` does not always match the object in the bucket.
 * `generateDOCKey` replaces every disallowed character with one underscore, so
 * "a - b.pdf" becomes "a___b.pdf". `getPresignedUrl` then uploads to
 * `key.replace(/_+/g, "_")`, which collapses that run to a single underscore,
 * but the uncollapsed key is what gets written to the database.
 *
 * The two only agree when the file name has no adjacent separators. Apply the
 * same collapse here so the URL points at the object that actually exists.
 */
export function buildDocumentUrl(storageKey?: string | null): string | null {
	if (!storageKey) return null;

	return `${SMART_PROFILE_BASE_URL}/${storageKey.replace(/_+/g, "_")}`;
}

/**
 * Normalises a file name so the key the API stores matches the key it uploads to.
 *
 * Applies both backend transformations up front, so `generateDOCKey` and
 * `getPresignedUrl` become no-ops and cannot disagree. This prevents new
 * mismatches; `buildDocumentUrl` is still needed for documents already stored.
 */
export function sanitizeFileName(fileName: string): string {
	return fileName.replace(/[^a-zA-Z0-9_.]/g, "_").replace(/_+/g, "_");
}
